var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('detected-speed',{on:{"network-type":_vm.handleNetworkIdentified,"network-speed":_vm.handleNetworkSpeed}}),_c('modal-lost-connection',{attrs:{"show":_vm.isOffline},on:{"close":_vm.closeModalLostConnection}}),_c('modal-slow-connection',{attrs:{"show":_vm.isSlowConnection},on:{"close":_vm.closeModalSlowConnection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }